/**
 * Taxonomy-based PLP route URL: parsing & building.
 *
 * Parses and builds the path-like, taxonomy-based product-discovery URLs of the
 * form `/<basePath>/<taxonomy...>/-/<filters...>`. See {@link parse} and
 * {@link build} for details, and the package README for the design rationale.
 *
 * @packageDocumentation
 */

export { build } from './build';
export { parse } from './parse';
export { RouteParseError } from './RouteParseError';
export type { BuildInput, ParsedSelection, ParseOptions, PathPart, Selection } from './types';
